import styled from 'styled-components';

export const DropdownHeader = styled.strong`
  display: flex;
  padding-left: var(--spacing-05);
  pointer-events: none;
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-base);
  color: var(--gray-70);
  font-size: var(--font-size-sm);
  margin: var(--spacing-01) 0;
`;
